import React, { ReactNode } from 'react';

import { Accordion, Flex, Text } from '@raystack/apsara';
import { For } from '@studio/hoc';

import styles from './styles.module.css';

export type control = {
  key: string;
  label: string;
  isLoading?: boolean;
  disabled?: boolean;
};

interface VisualizationControlsProps {
  controls: control[];
  renderControl: (key: string) => ReactNode;
}

export const VisualizationControls = React.memo(function VisualizationControls({
  controls,
  renderControl
}: VisualizationControlsProps) {
  return (
    <Accordion>
      <Accordion.Item value='controls'>
        <Accordion.Trigger>
          <Text size='small' variant='secondary'>
            Controls
          </Text>
        </Accordion.Trigger>

        <Accordion.Content className={styles.controlWrapper}>
          <Flex direction='column' align='start' gap={4} width='full'>
            <For each={controls}>
              {control => (
                <Flex
                  key={control.key}
                  justify='between'
                  align='center'
                  className={styles.control}
                  width='full'
                >
                  <Text variant='secondary' size='small'>
                    {control.label}
                  </Text>
                  {renderControl(control.key)}
                </Flex>
              )}
            </For>
          </Flex>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion>
  );
});
